import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertTo24HourFormat',
    standalone: false
})
export class ConvertTo24HourFormatPipe implements PipeTransform {
  transform(value: Date | null): string {
    const currentDate = new Date();
    const date = new Date(`${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()} ${value}`);

    if (isNaN(date.getTime())) {
      return '';
    }

    const formattedTime = Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale || 'en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).format(date);

    return formattedTime;
  }
}
